import { transition, trigger, style, animate, sequence } from '@angular/animations';

const DEFAULT_ANIMATION_TIME = 0.5;

const enterInitStyle = style({ opacity: 0, height: 0, transform: 'translateY(-50px) rotate(-5deg)' });
const addSpace = animate(
  `${DEFAULT_ANIMATION_TIME}s ease-out`,
  style({ opacity: 0, height: '*' })
);
const addTask = animate(
  `${DEFAULT_ANIMATION_TIME / 2}s ${DEFAULT_ANIMATION_TIME * 1.1}s ease-out`,
  style({ opacity: 1, transform: 'translateY(0) rotate(0deg)' })
);

const leaveInitStyle = style({ transform: 'translateX(0) rotate(0deg)' });
const removeTask = animate(
  `${DEFAULT_ANIMATION_TIME}s ease-out`,
  style ({ transform: 'translateX(-150%) rotate(-30deg)' })
);
const closeSpace = animate(
  `${DEFAULT_ANIMATION_TIME}s ${DEFAULT_ANIMATION_TIME * 1.1}s ease-out`,
  style ({ height: 0, opacity: 0 })
);

export const taskItemAnimation =
  trigger('taskItemAnimation', [
    transition(':enter', [
      enterInitStyle,
      sequence([
        addSpace,
        addTask
      ])
    ]),
    transition(':leave', [
      leaveInitStyle,
      sequence([
        removeTask,
        closeSpace
      ])
    ])
  ]);
